import { render } from "./CreateAudience.vue?vue&type=template&id=9154b3a4&scoped=true"
import script from "./CreateAudience.vue?vue&type=script&lang=js"
export * from "./CreateAudience.vue?vue&type=script&lang=js"

import "./CreateAudience.vue?vue&type=style&index=0&id=9154b3a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9154b3a4"]])

export default __exports__